import { createUseStyles } from 'react-jss'

const bp = {
  minWidth1: '1150px',
}

const useStyles = createUseStyles({
  content: {
    display: 'flex',
    flexFlow: 'column nowrap',
  },

  training: {
    display: 'flex',
    flexFlow: 'column',
    flex: '1',

    [`@media (min-width: ${bp.minWidth1})`]: {
      flexFlow: 'row',
    },
  },

  info: {
    display: 'flex',
    flexFlow: 'column nowrap',

    [`@media (min-width: ${bp.minWidth1})`]: {
      width: '31rem',
    },
  },

  sidePanel: {
    display: 'flex',
    flexFlow: 'column nowrap',
    position: 'relative',
    paddingTop: '1rem',

    [`@media (min-width: ${bp.minWidth1})`]: {
      flex: '1',
      borderLeft: '.0631rem solid #e8e8e8',
      marginLeft: '1.3rem',
      paddingLeft: '1.2rem',
      paddingTop: 0,
    },
  },

  summary: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '1rem',
  },

  observationsCount: {
    whiteSpace: 'nowrap',
  },

  annotationsPerClass: {
    textAlign: 'right',
  },

  tableActionsCell: {
    display: 'flex',
  },
})

export default useStyles
